export const EpostCell = {
  C4Envelope: 'c4_envelope',
  Color: 'color',
  CostIsOutdated: 'cost_is_outdated',
  DocumentTemplates: 'document_templates',
  Duplex: 'duplex',
  IsValidatedByEpost: 'is_validated_by_epost',
  Letters: 'letters',
  Loading: 'loading',
  PagesCount: 'pages_count',
  RegisteredLetter: 'registered_letter',
  SendToCalculateAt: 'send_to_calculate_at',
  TotalCost: 'total_cost',
  UkCredits: 'uk_credits',
  ValidationErrors: 'validation_errors_stats',
  Vendor: 'vendor',
  VendorTranslationKey: 'vendor_translation_key',
}

export const EPOST_POST_SERVICE_TRACKING_URL =
  'https://www.deutschepost.de/de/s/sendungsverfolgung.html'
